/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '@angular/forms';
import * as i3 from '../../../../common/formInput/formInput.component.ngfactory';
import * as i4 from '../../../../../../../app/components/common/formInput/formInput.component';
import * as i5 from '../../../../../../../app/common/directives/ripples.directive';
import * as i6 from '../../../../../../../app/components/calculator/public/mobile/price-tab/price-tab-v2.component';
import * as i7 from 'ngx-wizard';
import * as i8 from '../../../../common/publick-calculator-v2-title/publick-calculator-v2-title.component.ngfactory';
import * as i9 from '../../../../../../../app/components/common/publick-calculator-v2-title/publick-calculator-v2-title.component';
import * as i10 from '../../../../../../../app/services/google-tag.service';
const styles_PriceTabV2Component:any[] = ([] as any[]);
export const RenderType_PriceTabV2Component:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_PriceTabV2Component,data:{}});
function View_PriceTabV2Component_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),30,'div',[['class',
      'row value']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          27,'div',[['class','buttons price-block col-sm-12 height-size-2']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),3,'button',[['class',
          'btn-arrow cad']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.setCurrency('CAD')) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(278528,(null as any),0,i1.NgClass,[i0.IterableDiffers,
          i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,'klass'],ngClass:[1,
          'ngClass']},(null as any)),i0.ɵpod({'active':0}),(_l()(),i0.ɵted((null as any),
          ['CAD'])),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),
          (null as any),14,'form',[['novalidate','']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'submit'],[(null as any),
              'reset']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('submit' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,11).onSubmit($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,11).onReset()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i2.ɵbf,([] as any[]),
          (null as any),(null as any)),i0.ɵdid(16384,[['priceForm',4]],0,i2.NgForm,
          [[8,(null as any)],[8,(null as any)]],(null as any),(null as any)),i0.ɵprd(2048,
          (null as any),i2.ControlContainer,(null as any),[i2.NgForm]),i0.ɵdid(16384,
          (null as any),0,i2.NgControlStatusGroup,[i2.ControlContainer],(null as any),
          (null as any)),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),
          (null as any),7,'form-input',[['class','btn no-triangle bold'],['name','productValueInput'],
              ['placeholder','Enter value'],['step','0,1'],['type','number']],[[2,
              'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
              'keypress'],[(null as any),'ngModelChange']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('keypress' === en)) {
              const pd_0:any = ((<any>_co.decimalHandler($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_1:any = ((<any>(_co.currentValue = $event)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i3.View_FormInputComponent_0,i3.RenderType_FormInputComponent)),i0.ɵdid(4308992,
          [['productValueInput',4]],0,i4.FormInputComponent,[[2,i2.NG_VALIDATORS],
              [2,i2.NG_ASYNC_VALIDATORS]],{type:[0,'type'],name:[1,'name'],form:[2,
              'form'],placeholder:[3,'placeholder'],isPlaceholderNeed:[4,'isPlaceholderNeed'],
              autofocus:[5,'autofocus']},(null as any)),i0.ɵprd(1024,(null as any),
          i2.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i4.FormInputComponent]),i0.ɵdid(671744,(null as any),0,i2.NgModel,[[2,
          i2.ControlContainer],[8,(null as any)],[8,(null as any)],[2,i2.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],model:[1,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,
          (null as any),i2.NgControl,(null as any),[i2.NgModel]),i0.ɵdid(16384,(null as any),
          0,i2.NgControlStatus,[i2.NgControl],(null as any),(null as any)),i0.ɵdid(16384,
          (null as any),0,i5.RipplesDirective,[i0.ElementRef,i0.Renderer2],(null as any),
          (null as any)),(_l()(),i0.ɵted(0,[' '])),(_l()(),i0.ɵted((null as any),[' '])),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          3,'button',[['class','btn-arrow usd']],(null as any),[[(null as any),'click']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.setCurrency('USD')) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(278528,(null as any),0,i1.NgClass,
          [i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,
              'klass'],ngClass:[1,'ngClass']},(null as any)),i0.ɵpod({'active':0}),
      (_l()(),i0.ɵted((null as any),['USD'])),(_l()(),i0.ɵted((null as any),[' '])),
      (_l()(),i0.ɵted((null as any),[' ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = 'btn-arrow cad';
    const currVal_1:any = _ck(_v,6,0,(_co.currency.Name == 'CAD'));
    _ck(_v,5,0,currVal_0,currVal_1);
    const currVal_16:any = 'number';
    const currVal_17:any = 'productValueInput';
    const currVal_18:any = i0.ɵnov(_v,11);
    const currVal_19:any = 'Enter value';
    const currVal_20:any = true;
    const currVal_21:any = true;
    _ck(_v,16,0,currVal_16,currVal_17,currVal_18,currVal_19,currVal_20,currVal_21);
    const currVal_22:any = 'productValueInput';
    const currVal_23:any = _co.currentValue;
    _ck(_v,18,0,currVal_22,currVal_23);
    const currVal_24:any = 'btn-arrow usd';
    const currVal_25:any = _ck(_v,27,0,(_co.currency.Name == 'USD'));
    _ck(_v,26,0,currVal_24,currVal_25);
  },(_ck,_v) => {
    const currVal_2:any = i0.ɵnov(_v,13).ngClassUntouched;
    const currVal_3:any = i0.ɵnov(_v,13).ngClassTouched;
    const currVal_4:any = i0.ɵnov(_v,13).ngClassPristine;
    const currVal_5:any = i0.ɵnov(_v,13).ngClassDirty;
    const currVal_6:any = i0.ɵnov(_v,13).ngClassValid;
    const currVal_7:any = i0.ɵnov(_v,13).ngClassInvalid;
    const currVal_8:any = i0.ɵnov(_v,13).ngClassPending;
    _ck(_v,9,0,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8);
    const currVal_9:any = i0.ɵnov(_v,20).ngClassUntouched;
    const currVal_10:any = i0.ɵnov(_v,20).ngClassTouched;
    const currVal_11:any = i0.ɵnov(_v,20).ngClassPristine;
    const currVal_12:any = i0.ɵnov(_v,20).ngClassDirty;
    const currVal_13:any = i0.ɵnov(_v,20).ngClassValid;
    const currVal_14:any = i0.ɵnov(_v,20).ngClassInvalid;
    const currVal_15:any = i0.ɵnov(_v,20).ngClassPending;
    _ck(_v,15,0,currVal_9,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14,currVal_15);
  });
}
export function View_PriceTabV2Component_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),8,'tab',[['heading',
      'Value'],['previousButton','back']],[[2,'active',(null as any)],[2,'tab-pane',
      (null as any)]],[[(null as any),'onContinueClicked'],[(null as any),'isSelect']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:i6.PriceTabV2Component = _v.component;
        if (('onContinueClicked' === en)) {
          _co.setPriceToOI();
          const pd_0:any = ((<any>_co.focusInput(9)) !== false);
          ad = (pd_0 && ad);
        }
        if (('isSelect' === en)) {
          _co.onTabSelected.emit({pageTitle:'What is the approximate value?',pageOrder:90});
          _co.checkAndSetCurrency();
          const pd_1:any = ((<any>_co.googleTagService.pushData('price')) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(212992,(null as any),0,i7.TabDirective,
      [i7.TabsComponent,i0.ElementRef],{heading:[0,'heading'],previousButton:[1,'previousButton'],
          isNextButtonDisabled:[2,'isNextButtonDisabled'],buttonTemplate:[3,'buttonTemplate'],
          nextButton:[4,'nextButton'],index:[5,'index']},{isSelect:'isSelect',onContinueClicked:'onContinueClicked'}),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          1,'publick-calculator-v2-title',[['note','The value of product can determine duty and tax.'],
              ['title','What is the approximate value?']],(null as any),(null as any),
          (null as any),i8.View_PublicCalculatorV2TitleComponent_0,i8.RenderType_PublicCalculatorV2TitleComponent)),
      i0.ɵdid(49152,(null as any),0,i9.PublicCalculatorV2TitleComponent,([] as any[]),
          {title:[0,'title'],note:[1,'note']},(null as any)),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_PriceTabV2Component_1)),i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,
          i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵted((null as any),[' ']))],(_ck,_v) => {
    var _co:i6.PriceTabV2Component = _v.component;
    const currVal_2:any = 'Value';
    const currVal_3:any = 'back';
    const currVal_4:boolean = !_co.currentValue;
    const currVal_5:any = _co.wizardFooterTemplate;
    const currVal_6:any = 'Continue';
    const currVal_7:any = 8;
    _ck(_v,1,0,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
    const currVal_8:any = 'What is the approximate value?';
    const currVal_9:any = 'The value of product can determine duty and tax.';
    _ck(_v,4,0,currVal_8,currVal_9);
    const currVal_10:any = _co.currency;
    _ck(_v,7,0,currVal_10);
  },(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).active;
    const currVal_1:any = i0.ɵnov(_v,1).addClass;
    _ck(_v,0,0,currVal_0,currVal_1);
  });
}
export function View_PriceTabV2Component_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'price-tab-v2',
      ([] as any[]),(null as any),(null as any),(null as any),View_PriceTabV2Component_0,
      RenderType_PriceTabV2Component)),i0.ɵdid(49152,(null as any),0,i6.PriceTabV2Component,
      [i0.ChangeDetectorRef,i10.GoogleTagService],(null as any),(null as any))],(null as any),
      (null as any));
}
export const PriceTabV2ComponentNgFactory:i0.ComponentFactory<i6.PriceTabV2Component> = i0.ɵccf('price-tab-v2',
    i6.PriceTabV2Component,View_PriceTabV2Component_Host_0,{wizardComponent:'wizardComponent',
        order:'order',orderItem:'orderItem',canadianCurrencyCodes:'canadianCurrencyCodes',
        wizardFooterTemplate:'wizardFooterTemplate',focusInput:'focusInput'},{onTabSelected:'onTabSelected'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./compiled/app/components/calculator/public/mobile/price-tab/price-tab-v2.component.ngfactory.ts